var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Check_2",
    d: "M5.80525 10.6997L3.40503 8.2995C3.1399 8.03438 2.71006 8.03437 2.44494 8.2995C2.17981 8.56462 2.17981 8.99446 2.44493 9.25959L5.23957 12.0542C5.55199 12.3666 6.05852 12.3666 6.37094 12.0542L13.5546 4.8706C13.8197 4.60548 13.8197 4.17563 13.5546 3.91051C13.2894 3.64539 12.8596 3.64539 12.5945 3.91051L5.80525 10.6997Z",
    fill: "#41A451"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bd6053fc61913591dbaa6e9522b8a487.svg";
export { ForwardRef as ReactComponent };